import { Sangha } from "@app/shared/types";
import { useEffect, useState } from "react";
import { InterestGroupCommitmentDetailInfo } from "./InterestGroupCommitmentDetailInfo";
import { InterestGroupChooseCommitmentOptionsInfo } from "./InterestGroupChooseCommitmentOptionsInfo";
import { CommitmentOptions } from "./constants";
import PageWrapper from "components/PageWrapper";
import DocumentContext from "components/DocumentContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import IconButton from "@mui/material/IconButton";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { routes } from "app/routes";
import { useParams } from "react-router";
import makeStyles from "@mui/styles/makeStyles";

interface InterestGroupChooseCommitmentPageProps {
    interestGroup: Sangha;
    timezone: string;
    onCommitmentConfirmation: (isDropIn: boolean) => void;
    isSubmitting: boolean;
    isSwitchingGroupParticipation?: boolean;
}

const useStyles = makeStyles((theme) => ({
    reducedMarginWrapper: {
        marginTop: theme.spacing(0),
    },
}));

export const InterestGroupChooseCommitmentPage = (
    props: InterestGroupChooseCommitmentPageProps,
) => {
    const {
        interestGroup,
        timezone,
        onCommitmentConfirmation,
        isSubmitting,
        isSwitchingGroupParticipation,
    } = props;

    const classes = useStyles();

    const [commitmentOption, setCommitmentOption] = useState<CommitmentOptions | undefined>(
        undefined,
    );

    const dispatch = useDispatch();
    const { groupId } = useParams<{ groupId: string }>();

    const handleBackButtonClick = () => {
        if (commitmentOption !== undefined) {
            setCommitmentOption(undefined);
            window.sessionStorage.removeItem("isDropIn");
        } else {
            if (isSwitchingGroupParticipation) {
                dispatch(push(routes.memberHomePage()));
            } else {
                dispatch(push(routes.setupAddInterestGroup(groupId)));
            }
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [commitmentOption]);

    function getContent() {
        if (commitmentOption === CommitmentOptions.Commited) {
            return (
                <InterestGroupCommitmentDetailInfo
                    isDropIn={false}
                    onCommitmentConfirmation={onCommitmentConfirmation}
                    isSubmitting={isSubmitting}
                    interestGroup={interestGroup}
                    timezone={timezone}
                />
            );
        } else if (commitmentOption === CommitmentOptions.DropIn) {
            return (
                <InterestGroupCommitmentDetailInfo
                    isDropIn={true}
                    onCommitmentConfirmation={onCommitmentConfirmation}
                    isSubmitting={isSubmitting}
                    interestGroup={interestGroup}
                    timezone={timezone}
                />
            );
        } else {
            return (
                <InterestGroupChooseCommitmentOptionsInfo
                    setCommitmentOption={setCommitmentOption}
                    isSubmitting={isSubmitting}
                />
            );
        }
    }

    return (
        <>
            <DocumentContext title="Choose Your Commitment" addBrandNameSuffix />
            <PageWrapper
                className={classes.reducedMarginWrapper}
                data-testid="InterestGroupChooseCommitmentPage"
            >
                <IconButton onClick={handleBackButtonClick} aria-label="go back">
                    <ArrowBackIcon style={{ fontSize: "30px" }} />
                </IconButton>

                {getContent()}
            </PageWrapper>
        </>
    );
};
